import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "warehouseField", "userField", "salesOrderField", "salesPriceField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const deliveryType = this.selectTarget.value

    if (deliveryType === "warehouse") {
      this.showWarehouseFields()
      this.hideSalesFields()
    } else if (deliveryType === "direct_client") {
      this.hideWarehouseFields()
      this.showSalesFields()
    }
  }

  showWarehouseFields() {
    this.warehouseFieldTarget.style.display = ""
    this.userFieldTarget.style.display = ""
  }

  hideWarehouseFields() {
    this.warehouseFieldTarget.style.display = "none"
    this.userFieldTarget.style.display = "none"
  }

  showSalesFields() {
    this.salesOrderFieldTarget.style.display = ""
    this.salesPriceFieldTarget.style.display = ""
  }

  hideSalesFields() {
    this.salesOrderFieldTarget.style.display = "none"
    this.salesPriceFieldTarget.style.display = "none"
  }
}
